
import { computed, defineComponent, PropType } from 'vue'
import { MarketplaceIntegrationFeedback } from '../../../types/marketplace'
import moment from 'moment'

export default defineComponent({
    props: {
        integrationFeedbackItem: {
            type: Object as PropType<MarketplaceIntegrationFeedback>,
            required: true,
        },
        maxLines: {
            type: Number,
        },
    },
    setup(props) {
        const projectInitials = computed(() =>
            (props.integrationFeedbackItem.projectName || 'DH').trim().slice(0, 2).toUpperCase()
        )
        const starsLabel = computed(() => {
            const rating = Math.max(1, Math.min(5, Math.round(props.integrationFeedbackItem.rating || 0)))
            return '★'.repeat(rating)
        })
        const formatDate = (date: string) => moment(date).format('DD.MM.YYYY')

        return { projectInitials, starsLabel, formatDate }
    },
})
